import TagManager from "react-gtm-module";

function AccountInfoEdit({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "account_info_edit",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default AccountInfoEdit;
